import { deluxe_games_order, slot_games } from "../../constants/slot_games.js";
import { userData } from "../../js/api/profile.js";
import IframeModal from "../components/IframeModal.js";
import { getCurrentBalance, updatecasinocurrency } from "../../js/api/balance.js";
import { getGamesList, registerDeluxeCasino, loginDeluxeCasino, getNewStargames } from "../../js/api/deluxecasino.js"
import { _t } from "../../services/TranslationService.js";
import { isEuroVegasDomain } from "../../js/constants/global-variables.js";

// Deluxe Casino Games

// TODO: best_games from getGames to use for new category Popular
let Deluxe = {
  render: async () => {
    const starCasinoEnabled = localStorage.getItem("starCasinoEnabled") === "1";
    const noAccess = isEuroVegasDomain || !starCasinoEnabled;
    
    if (noAccess) {
      return `
        <h2 style="color:white;text-align:center;margin-top:50px;">Deluxe Casino is not supported on this domain.</h2>
        <div style="text-align:center;margin-top:20px;">
          <a href="#/" style="color:white;">Go to homepage</a>
        </div>
      `;
    }

    const getGames = await getGamesList();

    
    let group = getGames.gamelist.reduce((r, a) => {
      r[a.Platform] = [...r[a.Platform] || [], a];
      return r;
    }, {});
    
    let baseUrlIcons = getGames.baseURL3;
    let groupView = `
      <div class="searchGameHolder">
          <svg xmlns="http://www.w3.org/2000/svg" height="20" viewBox="0 0 24 24" width="20"><path d="M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5s4.
    5 2.01 4.5 4.5S11.99 14 9.5 14z"/></svg>
          <input type="search" id="searchGameInput" placeholder="${_t('Search game')}..." />
      </div>
    `;
    let groupBtnView = ``;

    if (getGames && getGames.best_games && getGames.best_games.length > 0) {
      // Render Popular category and games
      groupBtnView += `<div class="groupFamilyBtn active" data-btn-target="popular" data-sortindex="0" style="order: 0"><span class="">${_t('Popular')}</span></div>`;

      let gamesItemView = ``;
      for (const element of getGames.best_games) {
          gamesItemView += `
            <div class="game animation-element" game="${element.ID}" group="popular">
              <img src="${baseUrlIcons}${element.GameIconUrl}" loading="lazy" onerror="javascript:this.src='./img/games_icons/duser.jpg'" />
              <span>${element.Name}</span>
            </div>
          `;
      }
      groupView += `
          ${gamesItemView}
      `;
    }

    groupBtnView += `<div class="groupFamilyBtn" data-btn-target="all" data-sortindex="1" style="order: 1"><span class="">${_t('All games')}</span></div>`;

    $.each(group, function(i,item){
    
      let index = deluxe_games_order.length + 3;
      if (deluxe_games_order.includes(i.toUpperCase())) {
        index = deluxe_games_order.indexOf(i.toUpperCase()) + 2;
      }

      let gamesItemView = ``;
      groupBtnView += `
        <div class="groupFamilyBtn" data-btn-target="${i.replaceAll(' ', '')}" data-sortindex="${index}" style="order: ${index}"><span class="">${i}</span></div>
      `;
      for (const key in item) {
    
        if (Object.hasOwnProperty.call(item, key)) {
          const element = item[key];
      
          gamesItemView += `
            <div class="game animation-element" game="${element.ID}" group="${element.Platform.replaceAll(' ', '')}" style="display: none;">
              <img src="${baseUrlIcons}${element.GameIconUrl}" loading="lazy" onerror="javascript:this.src='./img/games_icons/duser.jpg'" />
              <span>${element.Name}</span>
            </div>
          `;
        }
      }
      groupView += `
        ${gamesItemView}
      `;
    })
    
    let view = /*html*/ `
         <div class="modalHelperHolder">
            <div class="modalHelperPosition">
                <span>Zgjedh monedhen per casino</span>
                <select id="coinSelectorSelect">
                </select>
                <a class="submitBtn modalHandler" id="submitCoinSelected">Vazhdo</a>
            </div>
        </div>

        <h1 class="deluxeTitle" >Welcome To Deluxe Games</h1>

        <div class="machineBoxesHolder landingMashineBox" style="overflow-x: auto; ">
          <div class="machineBox " game="">
              <a href="#/deluxe">
                  <img src="img/slider-01.svg" loading="lazy" />
              </a>
          </div>
          <div class="machineBox " game="">
              <a href="#/deluxe">
                  <img src="img/slider-02.svg" loading="lazy" />
              </a>
          </div>
          <div class="machineBox " game="">
              <a href="#/deluxe">
                  <img src="img/slider-03.svg" loading="lazy" />
              </a>
          </div>
          <div class="machineBox " game="">
              <a href="#/deluxe">
                  <img src="img/slider-05.svg" loading="lazy" />
              </a>
          </div>
          <div class="machineBox " game="">
              <a href="#/deluxe">
                  <img src="img/slider-06.svg" loading="lazy" />
              </a>
          </div>
        </div>
          
       <div class="slotsCatHolder">
            <div class="slotsCatHelper" id="slotsCatBtn" style="display: flex;">
              ${groupBtnView}
            </div>
       </div>
       <div class="slotsMainWrapper deluxeView">
          <div id="main" style="text-align: left;">
              ${groupView}
          </div>
       </div>
       `;
    return view;
  },
  after_render: async () => {
    const starCasinoEnabled = localStorage.getItem("starCasinoEnabled") === "1";
    const noAccess = isEuroVegasDomain || !starCasinoEnabled;
    if (noAccess) return;

    const userDataBody = await userData(localStorage.getItem("user_id"));
    if (!$("body").hasClass("bg-black")) {
      $("body").addClass("bg-black");
    }

    $("body").click(function (e) {
      if (!$(e.target).is(".modalHelperPosition,.modalHelperPosition *")) {
        $(".modalHelperHolder").removeClass("active");
      }
    });

    setCurrentBalanceForSlots();

    $("body .landingMashineBox").slick({
        dots: false,
        infinite: true,
        speed: 300,
        slidesToShow: 1,
        autoplay: true,
        autoplaySpeed: 5000,
        centerMode: true,
        variableWidth: false,
        dots: false,
        prevArrow: false,
        nextArrow: false,
    });

    var mainIndex = 0;
    let groupContent = "";

    for (let index = 0; index < slot_games.length; index++) {
      let content = "";
      const element = slot_games[index];
      for (let i = 0; i < element.Data.length; i++) {
        const e = element.Data[i].name;
        const id = element.Data[i].id
          ? element.Data[i].id
          : element.Data[i].name;
        // content += `<div class="game" familyid="${element.Type}" game="${e}"><span>${e}</span></div>`;
        content += `<div class="game animation-element" game="${id}"><img src="./img/games_icons/${id}.jpg" onerror="javascript:this.src='./img/games_icons/duser.jpg'"><span>${e}</span><svg xmlns="http://www.w3.org/2000/svg" id="Capa_1" enable-background="new 0 0 512 512" height="18" viewBox="0 0 512 512" width="18"><g><path d="m376 31c-54.544 0-95.017 33.497-120 81.015-24.981-47.515-65.454-81.015-120-81.015-78.609 0-136 66.015-136 146.515 0 106.457 101.572 173.291 246.122 299.773 5.657 4.949 14.099 4.948 19.756 0 144.417-126.366 246.122-193.303 246.122-299.773 0-80.513-57.4-146.515-136-146.515zm-120 415.101c-133.122-115.635-226-179.872-226-268.586 0-66.424 45.57-116.515 106-116.515 58.252 0 94.351 53.947 105.542 93.996 4.036 14.61 24.83 14.675 28.916 0 11.043-39.518 46.723-93.996 105.542-93.996 60.43 0 106 50.091 106 116.515 0 88.765-93.03 153.083-226 268.586z"></path></g></svg></div>`;
        // content += `<div class="game" game="${id}"><img src="/bettting_app/user/src/img/games_icons/${id}.jpg" /><span>${e}</span></div>`;
      }


      mainIndex++;
    }

    let catLengthWidth = 0;
    $(".groupFamilyBtn ").each(function (e) {
      catLengthWidth += $(this).outerWidth();
    });
    $("body .slotsCatHelper").css({
      width: catLengthWidth + 3 + "px",
    });

    // $("#main").html(groupContent);

    // Filter games by category
    $("body").on("click", ".groupFamilyBtn", function (e) {
      let eventTarget = $(e.currentTarget).attr("data-btn-target");
      $("body .groupFamilyBtn").removeClass("active");
      $(e.currentTarget).addClass("active");
      if (eventTarget === 'all') {
        $('.game').show();
      } else {
        $(".game[group='" + eventTarget + "']").show();
        $(".game").not("[group='" + eventTarget + "']").hide();
      }
    });

    // Search games
    $("#searchGameInput").unbind().on("keyup", function (e) {
      let value = $(e.currentTarget).val().toLowerCase();
      $("body .groupFamilyBtn").removeClass("active");
      $("body .groupFamilyBtn[data-btn-target='all']").addClass("active");
      if (!value) {
        $('.game').show();
        return;
      }
      $(".game").filter(function () {
        $(this).toggle($(this).text().toLowerCase().indexOf(value) > -1);
      });
    });
    $("#searchGameInput").on("search", function (e) {
      let value = $(e.currentTarget).val().toLowerCase();
      if (!value) {
        $('.game').show();
        return;
      }
    });

    $("body").on("click", "#submitCoinSelected", async function (e) {
      const res = await updatecasinocurrency($("#coinSelectorSelect").val());
      alert("Monedha u vendos, vazhdoni te luani!!");
      callSliderEvent();
    });

    $("body").on("click", ".machineBox", function (e) {
      if (
        !localStorage.getItem("access_token") ||
        localStorage.getItem("access_token") == ""
      ) {
        alert("Login!");
        return;
      }
      if (userDataBody.casinoEnabled != "1") {
        alert("Nuk keni qasje ne lojet e Casino!");
        return;
      }
      const gameName = $(e.currentTarget).attr("game");
      if (!gameName) return;
      const gameLink = `https://${
        location.host
      }/casino/index?game=${gameName}&u=${localStorage.getItem(
        "access_token"
      )}&sign=${btoa(localStorage.getItem('user_id'))}`;

      if (location.host == 'eccoplay365.com') {
        IframeModal.loadIframe(gameLink);
        IframeModal.show(gameName);
      } else {
        window.location.href = gameLink;
      }
    });
    
    $(".game").on("click",async function (e) {
      if (
        !localStorage.getItem("access_token") ||
        localStorage.getItem("access_token") == ""
      ) {
        alert("Login!");
        return;
      }

      if (userDataBody.casinoEnabled != "1") {
        alert("Nuk keni qasje ne lojet e Casino!");
        return;
      }
      
      let hasDeluxe = localStorage.getItem("hasDeluxe");

      if (hasDeluxe === null){
        let register = await registerDeluxeCasino();
        if (register && register['token']) {
          localStorage.setItem('access_token', register['token']);
          localStorage.setItem('hasDeluxe', true);
        }
      }

      let loginCasinoDeluxe = await loginDeluxeCasino();
      let casinoJwt = loginCasinoDeluxe.jwt;

      $(e.currentTarget).addClass("clicked");
      let gameName = $(e.currentTarget).attr('game');
  
      setTimeout(async function () {
          
        const gameLink = `https://${location.host}/gs/startgame?game_id=${gameName}&jwt=${casinoJwt}&sign=${btoa(localStorage.getItem('user_id'))}`;

        IframeModal.loadIframe(gameLink);
        IframeModal.show(gameName);
        $(e.currentTarget).removeClass("clicked");
      }, 2000);
    });
  },
};

async function setCurrentBalanceForSlots() {
  var currentBalanceResult = await getCurrentBalance();

  if (currentBalanceResult.casino_currency) return;

  var coins = [];

  if (currentBalanceResult && currentBalanceResult.total_coins) {
    var allCoins = currentBalanceResult.total_coins.split("|");

    if (currentBalanceResult.total_coins.includes("|")) {
      var allCoins = currentBalanceResult.total_coins.split("|");

      for (let index = 0; index < allCoins.length; index++) {
        const coin = allCoins[index];
        const currency = coin.split(";")[0].split(".")[1];
        coins.push({
          currency,
          id: coin.split(";")[0].split(".")[0],
        });

        const value = coin.split(";")[1];
      }
    } else {
      if (currentBalanceResult.currency) {
        coins.push({
          currency: currentBalanceResult.currency,
          id: currentBalanceResult.currency_id,
        });
      } else {
        const currency = currentBalanceResult.total_coins
          .split(";")[0]
          .split(".")[1];
        coins.push({
          currency,
          id: currentBalanceResult.total_coins.split(";")[0].split(".")[0],
        });
      }
    }
  }

  renderCoins(coins);
  callSliderEvent();
}

async function renderCoins(coins) {
  coins.forEach((element) => {
    $("#coinSelectorSelect").append(`<option value="${element.id}"> 
       ${element.currency}   
 </option>`);
  });
}

function callSliderEvent() {
  if ($("body .modalHelperHolder").hasClass("active")) {
    $("body .modalHelperHolder").removeClass("active");
  } else {
    $("body .modalHelperHolder").addClass("active");
  }
}

export default Deluxe;
